import {
  InitClient,
  GetByParas,
  Post,
  PostWithParas,
  PostNoParas
} from "../ZeusAPIClient.js";
import { apiConfig } from "../../config.js";
import { PagingBody } from "../Model/PagingBody";
import { Predicate } from "../Model/Predicate";
import { EncryptContent } from "../Logic/WikiLogic";
InitClient(apiConfig.clientId, apiConfig.clientSecret, apiConfig.host);
//获取短信分页列表
//title 标题名称
//appointNum 目标号码
async function GetSmsTaskPage(userId, title, appointNum, pageIndex, pageSize) {
  var predicates = [];
  if (userId) predicates.push(new Predicate("AddUserID", userId, "eq", 1));
  if (title) predicates.push(new Predicate("Title", title, "contain", 1));
  if (appointNum)
    predicates.push(new Predicate("AppointNumbers", appointNum, "contain", 1));
  predicates.push(new Predicate("IsDelete", "0", "eq", 1));
  var pb = new PagingBody(predicates, pageIndex, pageSize, "AddTime", "desc");
  return await Post("8fa913b4-bbfe-4333-8a3b-e3f117e236dd", pb);
}
//获取短信列表
//userid 当前用户ID
async function GetSmsTaskCount(userId) {
  var predicates = [];
  if (userId) predicates.push(new Predicate("AddUserID", userId, "eq", 1));
  predicates.push(new Predicate("IsDelete", "0", "eq", 1));
  var list = await Post("65A0F8C1-AD02-456D-B670-3A5F796EF9B8", predicates);
  var cnt = list.reduce(function (a, b) {
    return a.SucessCount + b.SucessCount;
  });
  return cnt;
}
//添加短信任务
async function AddSmsTask(task) {
  var data = await PostWithParas(
    "454eaed1-98eb-434c-8c4b-c8ec124d000a",
    "",
    task
  );
  data = data.replace('"', "");
  if (data == "success") {
    return true;
  } else {
    return false;
  }
}
//添加短信任务
async function UpdateSmsTask(task) {
  var paras = {
    ID: task.ID
  };
  var data = await PostWithParas(
    "ddd4f83b-0c8d-44ae-8632-c75169605720",
    paras,
    task
  );
  data = data.replace('"', "");
  if (data == "success") {
    return true;
  } else {
    return false;
  }
}
//获取单个
async function GetSingleSmsTask(Id) {
  var paras = { ID: Id };
  return await GetByParas("11dd357b-c05a-4991-b5b7-3696de35cfff", paras);
}
//发送短信
async function SendSms(dst, msg) {
  var request = { dst: dst, msg: msg, type: 'msg' };
  return await Post("d3af6702-c5fc-4d89-8432-f246cec88d51", request);
}

//获取剩余短信条数
async function GetSmsCount(predicates) {
  // var pb = new PagingBody(predicates, 0, 0, '', '');
  return Post("65A0F8C1-AD02-456D-B670-3A5F796EF9B8", predicates);
}


async function DoTask(task) {
  var taskRes = {
    status: 3,
    msg: ""
  };
  var dst = task.AppointNumbers.split(",");
  var res = await SendSms(task.AppointNumbers, task.Content);
  if (res.SuccessCount != 0 && res.SuccessCount == dst.length) {
    taskRes.status = 1;
    taskRes.msg = "发送成功";
  } else if (res.SuccessCount != 0 && res.SuccessCount < dst.length) {
    taskRes.status = 2;
    taskRes.msg = "部分发送成功";
  } else if (res.SuccessCount == 0) {
    taskRes.status = 3;
    taskRes.msg = "发送失败";
  }
  task.Status = taskRes.status;
  task.TaskBeginTime = new Date();
  task.SucessCount = res.SuccessCount;
  task.Content = await EncryptContent(task.Content);
  //console.log(res);
  task.SuccessNumbers =
    res.SuccessNumbers.length > 0 ? res.SuccessNumbers.join(",") : "";
  task.ErrorMsg = res.Msg;
  var flag = await UpdateSmsTask(task);
  if (flag) {
    return taskRes;
  }
}
export {
  GetSmsTaskPage,
  GetSmsTaskCount,
  AddSmsTask,
  UpdateSmsTask,
  GetSingleSmsTask,
  SendSms,
  DoTask,
  GetSmsCount
};
